import { Injectable } from '@angular/core';

import {  NavController } from '@ionic/angular';
import { HttpService } from '../_provider/http.service';
import { JwtHelperService } from '@auth0/angular-jwt';

const helper = new JwtHelperService()

@Injectable({
  providedIn: 'root'
})
export class AuthGuardLoginService  {

  constructor(private http: HttpService, private navCtrl: NavController) { }

  canActivate(): boolean{
    let decoded = helper.decodeToken(this.http.token)
    if(!this.http.token) return true
    else {
      if(decoded.role.includes("employee") || decoded.role == "employee") this.navCtrl.navigateRoot("/tabs/home")
      else if(decoded.role == "customer") this.navCtrl.navigateRoot("/customer")
      return false
    }
  }
}
